export default __webpack_public_path__ + "static/gw2-icon-your-inventory-9d3f0675c28f20af0179502f461cf189.png";